/**
 * Regex pattern matching markdown links to player pages (e.g. `[Messi](/players/123)`)
 * Uses atomic-style possessive matching via length limit to prevent backtracking
 * Captures the link text (player name) in group 1
 */
const PLAYER_LINK_PATTERN = /\[([^\]]{1,200})\]\(\/players\/\d{1,20}\)/;

/**
 * Extracts the first player name from markdown content containing player links
 * Searches for the first `[PlayerName](/players/ID)` pattern and returns the name
 * @param markdownContent - Markdown string potentially containing player link references
 * @returns The first player name found, or empty string if none present
 */
export function extractFirstPlayerName(markdownContent: string): string {
  const match = PLAYER_LINK_PATTERN.exec(markdownContent);
  return match?.[1] ?? "";
}
